import { preprocess } from '@artica/assets';
import { take } from '@immutabl3/utils';

preprocess('hero_path', function preprocessHero(heropath) {
  return take([...heropath.children], 5)
    .filter(({ isLine }) => isLine);
});